// removed by extract-text-webpack-plugin
module.exports = {"header":"_2rmIa _2oaig _28zmO","actionHeader":"_3PXmC _2k2oP _1-OXK _3Xg8b","selectedCount":"_2Ztnm _155vN","allCheckbox":"_11AzK undefined","selected":"_3xk3M","actionButton":"ieq3w _2NBY4 _1wqBz _1v96X _1-OXK _3Xg8b"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/ActionHeader.css
// module id = 2013
// module chunks = 3